export default "__VITE_ASSET__C_s8HNvD__"